import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ExcelDownloadTemplateType, FileType } from 'src/service/file-save.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FileUploadFor, LocalService } from 'src/service/local.service';
import { RequestManagementService } from 'src/service/request-management.service';

@Component({
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent {
  FileUploadFor = FileUploadFor;
  @ViewChild('content_bulk_upload') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() excelTemplateType: ExcelDownloadTemplateType = ExcelDownloadTemplateType.None;

  lstSectionConfigKeys: string[] = ["bulk"];

  constructor(public localService: LocalService, private offcanvasService: NgbOffcanvas, private languageManagementService: LanguageManagementService, private requestManagementService: RequestManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {

  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.requestManagementService.downloadExcelTemplate(this.excelTemplateType).subscribe(result => {
          if (result && result.length > 0) {
            this.localService.onDownloadFile(result, '', FileType.XLSX, this.excelTemplateType);
          } else {
            this.localService.showInformation(this.localService.languageContent.bulk.template_unavailable, true);
          }
        });
      } break;
    }
  }
}
